__turbopack_context__.v({
  "loadingCell": "LoadingBucket-module-scss-module__B5i3ma__loadingCell",
  "loadingGrid": "LoadingBucket-module-scss-module__B5i3ma__loadingGrid",
  "shimmer": "LoadingBucket-module-scss-module__B5i3ma__shimmer",
  "skeleton": "LoadingBucket-module-scss-module__B5i3ma__skeleton",
  "skeletonImage": "LoadingBucket-module-scss-module__B5i3ma__skeletonImage",
  "skeletonLine": "LoadingBucket-module-scss-module__B5i3ma__skeletonLine",
  "skeletonTitle": "LoadingBucket-module-scss-module__B5i3ma__skeletonTitle",
});
